import { render, staticRenderFns } from "./Weighing.vue?vue&type=template&id=4775bcf0&scoped=true"
import script from "./Weighing.vue?vue&type=script&lang=js"
export * from "./Weighing.vue?vue&type=script&lang=js"
import style0 from "./Weighing.vue?vue&type=style&index=0&id=4775bcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4775bcf0",
  null
  
)

export default component.exports